var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66927 5.35156C3.10446 5.35156 1.83594 6.62009 1.83594 8.1849C1.83594 9.7497 3.10446 11.0182 4.66927 11.0182H6.0026C6.27875 11.0182 6.5026 11.2421 6.5026 11.5182C6.5026 11.7944 6.27875 12.0182 6.0026 12.0182H4.66927C2.55218 12.0182 0.835938 10.302 0.835938 8.1849C0.835938 6.0678 2.55218 4.35156 4.66927 4.35156H6.0026C6.27875 4.35156 6.5026 4.57542 6.5026 4.85156C6.5026 5.1277 6.27875 5.35156 6.0026 5.35156H4.66927ZM9.5026 4.85156C9.5026 4.57542 9.72646 4.35156 10.0026 4.35156H11.3359C13.453 4.35156 15.1693 6.0678 15.1693 8.1849C15.1693 10.302 13.453 12.0182 11.3359 12.0182H10.0026C9.72646 12.0182 9.5026 11.7944 9.5026 11.5182C9.5026 11.2421 9.72646 11.0182 10.0026 11.0182H11.3359C12.9007 11.0182 14.1693 9.7497 14.1693 8.1849C14.1693 6.62009 12.9007 5.35156 11.3359 5.35156H10.0026C9.72646 5.35156 9.5026 5.1277 9.5026 4.85156ZM4.16927 8.1849C4.16927 7.90875 4.39313 7.6849 4.66927 7.6849L11.3359 7.6849C11.6121 7.6849 11.8359 7.90875 11.8359 8.1849C11.8359 8.46104 11.6121 8.6849 11.3359 8.6849L4.66927 8.6849C4.39313 8.6849 4.16927 8.46104 4.16927 8.1849Z",
    fill: "#6E00BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.7931971e05d2514ecc83c75169613a5c.svg";
export { ForwardRef as ReactComponent };